import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class LocationService {
  get pathname(): string {
    return window.location.pathname;
  }

  get href(): string {
    return window.location.href;
  }

  get origin(): string {
    return window.location.origin;
  }

  navigate(url: string): void {
    window.location.href = url;
  }

  reload(): void {
    window.location.reload();
  }
}
